import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaSearch } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const Buscador = ({ placeholder, palabra, estadoBusqueda, setEstadoBusqueda, escribiendo, setEscribiendo, setAlerta }) => {

  const [palabraIntroducida, setPalabraIntroducida] = useState(palabra);
  let tiempoEspera = "";
  const [urlPadre, seturlPadre] = useState();
  const navigate = useNavigate();
  const url = new URL(window.location);
  const params = new URLSearchParams(url.search);
  let pagina = params.get("pagina");


  useEffect(() => {
    seturlPadre(window.location.pathname);

    comprobarBusqueda(palabraIntroducida);
  }, [])

  const cambioDelImput = (event) => {
    const newValue = event.target.value;
    setPalabraIntroducida(newValue);
    comprobarBusqueda(newValue)

  };
  const comprobarBusqueda = (busqueda) => {
    if (busqueda === null || busqueda === "") {
      setEstadoBusqueda(false);
      setEscribiendo(false);
      setPalabraIntroducida("");
      setAlerta(false);
      navigate(urlPadre);
    } else {
      setEstadoBusqueda(true);
      setEscribiendo(true);
      pagina = params.set("pagina", 1);
    }
  }

  const gestionBuscador = (value) => {
    setEscribiendo(false);

  };

  useEffect(() => {

    if (escribiendo) {
      tiempoEspera = setTimeout(() => {
        gestionBuscador(palabraIntroducida);

       navigate(`${urlPadre}?pagina=${pagina}&busqueda=${palabraIntroducida || ''}`);


      }, 1000);
      return () => clearTimeout(tiempoEspera);
    }


    return () => clearTimeout(tiempoEspera);
  }, [palabraIntroducida, escribiendo]);

  const limpiarInput = () => {
    setEstadoBusqueda(false);
    setEscribiendo(false);
    setPalabraIntroducida("");
    setAlerta(false);
    navigate(urlPadre);
  };

  return (
    <>
      <ContenedorBuscador>
        <div className='busqueda'>
          <div className='inputsDeBusqueda'>
            <input type='text' placeholder={placeholder} value={palabraIntroducida} onChange={cambioDelImput} />
            <div className='iconoDeBusqueda'>
              {estadoBusqueda ? <IoMdCloseCircle id="clearBtn" onClick={limpiarInput} /> : <FaSearch />}
            </div>
          </div>
        </div>
      </ContenedorBuscador>
    </>
  );
}

export default Buscador;

const ContenedorBuscador = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1%;

  .inputsDeBusqueda {
    display: flex;
  }

  .busqueda input {
    border: 1px solid black;
    border-radius: 5px;
    font-size: 18px;
    padding: 15px;
    height: 40px;
    width: 300px;
    @media (max-width: 500px) {
      width: 180px;
    }
  }

  .iconoDeBusqueda {
    height: 40px;
    width: 50px;
    border: 1px solid black;
    border-radius: 5px;
    display: grid;
    place-items: center;
  }

  input:focus {
    outline: none;
  }

  .iconoDeBusqueda svg {
    font-size: 35px;
  }

  #clearBtn {
    cursor: pointer;
  }
`;

